export default __webpack_public_path__ + "static/media/Cloudy.d96dcfb8.png";